import { GetResult } from "@/api/types";
import { GetData, getResultToGetData } from "@/utilities/api";
import { Tooltip } from "antd";
import Skeleton from "../Skeleton/Skeleton";
import StatusTag, { DataStatBackground } from "../StatusTag/StatusTag";
import styles from "./StatusTags.module.scss";

export function DataStatsTags({ data, loading }: { data?: GetResult; loading?: boolean }) {
  return (
    <StatusTags
      data={getResultToGetData(data)}
      loading={loading}
    />
  );
}

export default function StatusTags({
  data,
  loading,
  hideTotal,
  background,
  calculatingTooltip,
  errorTooltip,
}: {
  data: Omit<Omit<GetData, "data">, "status"> | undefined;
  loading?: boolean;
  hideTotal?: boolean;
  background?: DataStatBackground;
  calculatingTooltip?: string;
  errorTooltip?: string;
}) {
  const count = data?.total_count;
  const completeCount = data?.complete_count;
  const incompleteCount = data?.incomplete_count;
  const outOfScopeCount = data?.out_of_scope_count;
  const duplicateCount = data?.duplicate_count;
  const correctCount = data?.correct_count;
  const errorsCount = data?.error_count;
  const calculatingCount = data?.calculating_count;
  const ignoredCount = data?.ignored_count;

  return (
    <div className={styles.NewDataStatsTags}>
      {loading ? (
        <>
          {hideTotal !== true && <Skeleton style={{ width: "40px", height: "16px" }} />}
          <Skeleton style={{ width: "90px", height: "24px" }} />
          <Skeleton style={{ width: "60px", height: "24px" }} />
        </>
      ) : (
        <>
          {hideTotal !== true && count !== undefined && (
            <>
              <span className={styles.total}>{count} Total</span>
            </>
          )}
          {!!(completeCount && completeCount > 0) && (
            <StatusTag
              background={background}
              status={"complete"}
              number={completeCount}
            />
          )}
          {!!(correctCount && correctCount > 0) && (
            <StatusTag
              background={background}
              status={"correct"}
              number={correctCount}
            />
          )}
          {!!(incompleteCount && incompleteCount > 0) && (
            <StatusTag
              background={background}
              status={"incomplete"}
              number={incompleteCount}
            />
          )}
          {!!(outOfScopeCount && outOfScopeCount > 0) && (
            <StatusTag
              background={background}
              status={"out_of_scope"}
              number={outOfScopeCount}
            />
          )}
          {!!(ignoredCount && ignoredCount > 0) && (
            <StatusTag
              background={background}
              status={"ignored"}
              number={ignoredCount}
            />
          )}
          {!!(errorsCount && errorsCount > 0) && (
            <Tooltip title={errorTooltip}>
              <>
                <StatusTag
                  background={background}
                  status={"error"}
                  number={errorsCount}
                />
              </>
            </Tooltip>
          )}
          {!!(duplicateCount && duplicateCount > 0) && (
            <StatusTag
              background={background}
              status={"duplicate"}
              number={duplicateCount}
            />
          )}
          {!!(calculatingCount && calculatingCount > 0) && (
            <Tooltip title={calculatingTooltip}>
              <>
                <StatusTag
                  background={background}
                  status={"calculating"}
                  number={calculatingCount}
                />
              </>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
}
